angular.module('igs.messageBox', ['ui.bootstrap'])

    .controller('MessageBoxController', [
        '$scope',
        '$modalInstance',
        'data',
        function($scope, $modalInstance, data) {
            $scope.data = data;

            $scope.buttonPressed = function(result) {
                $modalInstance.close(result);
            };
        }
    ])

    .factory('igs.messageBox', [
        '$modal', '$sce',
        function($modal, $sce) {
            return {

                open: function (title, message, buttons) {

                    var data = {};
                    data.title = title;
                    data.message = $sce.trustAsHtml(message);
                    data.buttons = buttons;

                    var modalInstance = $modal.open({
                        template: "<div><div class=\"modal-header\"><h3>{{data.title}}<\/h3><i class=\"pull-right fa fa-exclamation\" style=\"color: red; font-size: 24px; margin-top:-40px; padding-right: 10px;\"><\/i><\/div>" +
                                  "<div class=\"modal-body\"><p ng-bind-html='data.message'><\/p><\/div>" +
                                  "<div class=\"modal-footer\" style=\"padding-bottom: 10px\"><button id={{button.label}} class=\"btn ng-scope\" ng-repeat=\"button in data.buttons\" ng-class=\"button.cssClass\" ng-click=\"buttonPressed(button.result)\">{{button.label}}<\/button><\/div><\/div>",
                        controller: 'MessageBoxController',
                        resolve: {
                            data: function () { return data; }
                        }
                    });

                    return modalInstance.result;
                },

                show: function (config) {

                    var modalInstance = $modal.open({
                        templateUrl: config.templateUrl,
                        template: config.template,
                        controller: config.controller || 'MessageBoxController',
                        controllerAs: config.controllerAs,
                        windowClass: config.windowClass || '',
                        resolve: config.resolve || {},
                        backdrop: config.backdrop !== undefined ? config.backdrop : true
                    });

                    return modalInstance.result;
                }
            };
        }
    ]); 
